import { Addresses } from '@/domain/addresses';
import { getChainConstant } from '@/domain/chain';
import useChainId from '@/hooks/useChainId';
import SweepWarsAbi from '@/infrastructure/abis/SweepWarsAbi';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Address } from 'viem';
import { useWaitForTransactionReceipt, useWriteContract } from 'wagmi';

const useVoteOnSweepWar = () => {
  const client = useQueryClient();
  const chainId = useChainId();
  const {
    writeContract,
    error,
    isPending,
    data: hash,
    reset,
  } = useWriteContract();

  const vote = (vote: [collection: Address, amount: bigint]) =>
    writeContract({
      abi: SweepWarsAbi,
      address: getChainConstant(Addresses, chainId, 'SweepWars'),
      functionName: 'vote',
      args: vote,
    });

  const {
    data,
    isSuccess: isConfirmed,
    isLoading: isConfirming,
  } = useWaitForTransactionReceipt({
    hash,
    query: {
      // prevent previous tx state from being used
      placeholderData: undefined,
    },
    chainId,
  });

  useEffect(() => {
    if (isConfirmed) {
      setTimeout(() => {
        client.refetchQueries({
          queryKey: ['userActiveVotes'],
          exact: false,
        });
        client.refetchQueries({ queryKey: ['epochs'], exact: false });
      }, 1500);
      setTimeout(() => {
        console.log('refetching epoch');
        client.refetchQueries({ queryKey: ['epoch'], exact: false });
        reset();
      }, 3000);
    }
  }, [isConfirmed, client, reset, hash]);

  return {
    vote,
    error,
    receipt: data,
    isPending,
    isConfirming,
    isConfirmed,
  };
};

export default useVoteOnSweepWar;
